/**
 * @generated SignedSource<<6dbe1ebd724545ff47142bc93e99a17b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GeneratePaymentOrderInput = {
  amountCents: number;
  tokenId: string;
};
export type ExternalDepositViewGeneratePaymentOrderMutation$variables = {
  input: GeneratePaymentOrderInput;
};
export type ExternalDepositViewGeneratePaymentOrderMutation$data = {
  readonly generatePaymentOrder: {
    readonly payAddress: string;
    readonly memo: string | null;
  } | null;
};
export type ExternalDepositViewGeneratePaymentOrderMutation = {
  variables: ExternalDepositViewGeneratePaymentOrderMutation$variables;
  response: ExternalDepositViewGeneratePaymentOrderMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GeneratePaymentOrderPayload",
    "kind": "LinkedField",
    "name": "generatePaymentOrder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "payAddress",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "memo",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExternalDepositViewGeneratePaymentOrderMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalDepositViewGeneratePaymentOrderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0a8adabe59900cfa16295c04e7343a2e",
    "id": null,
    "metadata": {},
    "name": "ExternalDepositViewGeneratePaymentOrderMutation",
    "operationKind": "mutation",
    "text": "mutation ExternalDepositViewGeneratePaymentOrderMutation(\n  $input: GeneratePaymentOrderInput!\n) {\n  generatePaymentOrder(input: $input) {\n    payAddress\n    memo\n  }\n}\n"
  }
};
})();

(node as any).hash = "c489aa9d8a000610a58f5ea26f98c164";

export default node;
